import { render, staticRenderFns } from "./AddMenuGroup.vue?vue&type=template&id=35537d4a&scoped=true"
import script from "./AddMenuGroup.vue?vue&type=script&lang=js"
export * from "./AddMenuGroup.vue?vue&type=script&lang=js"
import style0 from "./AddMenuGroup.vue?vue&type=style&index=0&id=35537d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35537d4a",
  null
  
)

export default component.exports